export default {
  navbar: {
    home: 'Home',
    shipping: 'Shipping',
    faq: 'LiHaiBC',
    returns: 'Returns Policy',
    trackOrder: 'Track Order',
    search: 'Search',
    user: 'User',
    cart: 'Cart',
    favorite: 'Favorite',
    usd: 'USD',
    eng: 'ENG',
    zhong: '中文'
  },
  menu: {
    category1: 'Aromatherapy',
    category2: 'Intangible Heritage',
    category3: 'Canal Culture',
    homeFragrance: 'Home Fragrance',
    carFragrance: 'Car Fragrance',
    incense: 'Traditional Incense',
    commercialFragrance: 'Commercial Fragrance',
    copper: 'Zhu Bingren Copper',
    ceramics: 'Jingdezhen Ceramics',
    yixing: 'Yixing Pottery',
    lecture: 'Canal Accessories',
    life: 'Canal Lifestyle',
    creative: 'Canal Creative',
    experience: 'Canal Experience',
    gift: 'Canal Gifts',
    latestNews: 'Latest News',
    about: 'About Us',
    lihaibc: 'Lihaibc',
    contact: 'Contact Us',
    join: 'Cooperation'
  },
  footer: {
    brand: 'Cornflower',
    description: 'Focusing on high-quality natural fragrance and cultural products, letting every scent touch your heart.',
    contactUs: 'Contact Us',
    phone: '010-85858123',
    email: 'Email',
    emailAddr: 'huhanlin@@lihaibc.com',
    address: 'Address',
    addressText: '5th Floor, Zhengtai Building, Binjiang District, Hangzhou City, Zhejiang Province, Lihai Business Circle (Hangzhou) Internet Co., Ltd.',
    quickLinks: 'Quick Links',
    home: 'Home',
    homeFragrance: 'Home Fragrance',
    carFragrance: 'Car Fragrance',
    incense: 'Traditional Incense',
    aboutUs: 'About Us',
    contact: 'Contact Us',
    resources: 'Resources & Services',
    faq: 'FAQ',
    shipping: 'Shipping Policy',
    returns: 'Returns Policy',
    privacy: 'Privacy Policy',
    adminPortal: 'Cooperation & Agency',
    adminLogin: 'ResellerLogin',
    copyright: 'Cornflower Fragrance. All Rights Reserved.',
    AfterSalesService: 'After-sales Service'
  },
  common: {
    home: 'Home',
    product: 'Product',
    productDetail: 'Product Detail',
    price: 'Price',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    quantity: 'Quantity',
    stock: 'Stock',
    category: 'Category',
    all: 'All',
    sort: 'Sort',
    sortBy: 'Sort by',
    sales: 'Sales',
    priceAsc: 'Price: Low to High',
    priceDesc: 'Price: High to Low',
    found: 'Found',
    items: 'items',
    noProducts: 'No products available',
    loading: 'Loading...',
    submit: 'Submit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    success: 'Success',
    error: 'Error',
    required: 'Required',
    optional: 'Optional'
  },
  login: {
    title: 'User Login',
    login: 'Login',
    username: 'Username',
    usernamePlaceholder: 'Enter username or email',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    registerNow: 'Register now',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed'
  },
  register: {
    title: 'User Register',
    register: 'Register',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    phone: 'Phone',
    hasAccount: 'Already have an account?',
    loginNow: 'Login now',
    registerSuccess: 'Registration successful'
  },
  contact: {
    title: 'Contact Us',
    companyName: 'Company Name',
    contactPerson: 'Contact Person',
    phone: 'Phone',
    email: 'Email',
    message: 'Message',
    submit: 'Submit Message',
    success: 'Message submitted successfully',
    required: 'Please fill in'
  },
  productDetail: {
    price: 'Price',
    stock: 'Stock',
    quantity: 'Quantity',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    productDetail: 'Product Detail',
    intro: 'Introduction',
    specParams: 'Specifications',
    spec: 'Specification'
  },
wishlist: {
    productName: 'Product Name',
    specification: 'Specification',
    salesPrice: 'Sales Price',
    activePrice: 'Active Price',
    stock: 'Stock',
    quantity: 'Quantity',
    action: 'Action',
    addToCart: 'Add to Cart',
    noItems: 'No items in wishlist',
    loading: 'Loading...',
    addedToCart: 'Added to cart',
    loginFirst: 'Please login first',
    addFailed: 'Failed to add to cart'
  },
  shoppingCart: {
    productName: 'Product Name',
    specification: 'Specification',
    price: 'Price',
    quantity: 'Quantity',
    action: 'Action',
    selectAll: 'Select All',
    totalPrice: 'Total',
    totalQuantity: 'Total',
    items: 'items',
    checkout: 'Checkout',
    noItems: 'Your cart is empty',
    loading: 'Loading...',
    delete: 'Delete',
    loginFirst: 'Please login first',
    addFailed: 'Failed to add to cart',
    paypal: 'PayPal',
    wechat: 'WeChat Pay',
    alipay: 'Alipay',
    confirmPay: 'Confirm Payment',
    cancel: 'Cancel'
  },
  user: {
    title: 'My Account',
    profile: 'Profile',
    orders: 'My Orders',
    address: 'Shipping Address',
    favorite: 'My Favorites',
    wishlist: 'My Wishlist',
    settings: 'Settings',
    logout: 'Logout'
  },
  news: {
    latestNews: 'Latest News',
    readMore: 'Read More',
    publishDate: 'Publish Date',
    clicks: 'Views',
    likes: 'Likes'
  }
}